import React, { useState } from "react";

function NavBar() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <nav className="nav-bar">
      <div className="nav-brand">
        busola<span>.</span>dev
      </div>

      <div className={`nav-links ${open ? "open" : ""}`}>
        <a href="#about"    onClick={closeMenu}>About</a>
        <a href="#skills"   onClick={closeMenu}>Skills</a>
        <a href="#projects" onClick={closeMenu}>Projects</a>
        <a href="#contact"  onClick={closeMenu}>Contact</a>
        <a
          href="https://github.com/beejay321"
          target="_blank"
          rel="noreferrer"
          className="nav-cta"
          onClick={closeMenu}
        >
          GitHub ↗
        </a>
      </div>

      <button
        className={`menubtn ${open ? "open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle navigation menu"
        aria-expanded={open}
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
}

export default NavBar;
